<!-- icon自定义svg组件 -->
<template>
  <img class="icon-img" :src="`${require(`./images/${iconData}.png`)}`" alt="" />
</template>
 
<script>

export default {
  name: 'IconSvg',
  components: {

  },
  props: {
    iconData: {
      type: String,
      required: true,
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {

  },
  watch: {
    iconData: {
      handler(newVal, oldVal) {
        if (newVal) {
        }
      },
      immediate: true
    }
  }
}
</script>
 
<style scoped lang="less">
.icon-img {
  width: 13px;
  width: 13px;
  margin-right: 8px;
}
</style>